// export const smsUrl = "https://us-central1-servicesms-df0dc.cloudfunctions.net/api/single"
// export const smsAuthorization = "Basic dW5pdHh0Y2xpZW50MTpVSm1FajVIYUFNTHZlbDdpWFRoY1kyd2xXNEptbkpwOQ=="
export const mailerUrl = "https://us-central1-servicescheduler-af9f2.cloudfunctions.net/sendmail"
export const smsAuthorization = "Bearer 7CEs0OvA52yFNgMojM8TzY3nhAqH7hYdyRkubrm8F8"
export const contentType = "application/json"

// ************ development stage **************
// export const stage = "_dev"
// export const clientUrl = "dev.aftersales.scinnova.com.ph"
// export const branchUrl = "dev.branch.aftersales.scinnova.com.ph"
// export const adminUrl = "dev.admin.aftersales.scinnova.com.ph"
// export const createCustomer = "https://nsjonah-uat.scinnova.com.ph/restlet/customers/jo"
// export const consumerKey = "d053394b58de7c331aa37b206d5fc7e6ecc493f435e1ab4fb456a8eadc5ca4df"
// export const consumerSecret = "175bad0d6b9b649e69178b34585d35ebbc2e9a4bd7413d0436b6f5f959f28cfd"
// export const tokenId = "e448c4d94e6147836ee8b2fd8b513985261843901df1295cd21a417caf1e18a4"
// export const tokenSecret = "2cfe3e1027fc48da94a004d634381ae2a9fad7431413421c3137678df8286c3a"
// export const smsUrl = "https://sms.8x8.com/api/v1/subaccounts/SC_O_Service/messages"

// ************ staging stage **************
export const stage = "_staging"
export const clientUrl = "staging.aftersales.scinnova.com.ph"
export const branchUrl = "staging.branch.aftersales.scinnova.com.ph"
export const adminUrl = "staging.admin.aftersales.scinnova.com.ph"
export const createCustomer = "https://nsjonah-uat.scinnova.com.ph/restlet/customers/jo"
export const consumerKey = "d053394b58de7c331aa37b206d5fc7e6ecc493f435e1ab4fb456a8eadc5ca4df"
export const consumerSecret = "175bad0d6b9b649e69178b34585d35ebbc2e9a4bd7413d0436b6f5f959f28cfd"
export const tokenId = "e448c4d94e6147836ee8b2fd8b513985261843901df1295cd21a417caf1e18a4"
export const tokenSecret = "2cfe3e1027fc48da94a004d634381ae2a9fad7431413421c3137678df8286c3a"
export const smsUrl = "https://sms.8x8.com/api/v1/subaccounts/SC_O_Service/messages"

// ************ production stage **************
// export const stage = "_prod"
// export const clientUrl = "https://service-scheduler.transcycle.com.ph"
// export const branchUrl = "branch.aftersales.scinnova.com.ph"
// export const adminUrl = "admin.aftersales.scinnova.com.ph"
// export const createCustomer = "https://nsjonah.scinnova.com.ph/restlet/customers/jo"
// export const consumerKey = "67e10df831a44e610aede9423749401363e28bd52d1c5615952b4cbdb4f7b182"
// export const consumerSecret = "d7d8fac5228339bddc237e38060722a5ab334a2c8c5c5af6fea49bb54f103829"
// export const tokenId = "344d22b848a238144143d6af1db839356a8a9497b99ea61725f6aa6c63c9a45f"
// export const tokenSecret = "4a982c7162ad4993e691dc7ae5ecd3fe8d2e189b5f31f92c56c2b14b37522143"
// export const smsUrl = "https://sms.8x8.com/api/v1/subaccounts/SC_O_Service/messages"

